export default __webpack_public_path__ + "static/media/24-EXT-(2-3).92f4dc48.jpg";